import axios from '@/plugins/axiosInstance'
import { dashboard } from '@/networking/urlManager'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Fetch trends based on selected type
 * @param {string} assetId - Asset ID
 * @param {number} trendKeywordType - Type of trend keywords to fetch
 * @param {string} errorMessage - Error message to display if fetch fails
 * @returns {Promise<Object[]>} Array of trend objects
 */
export const getTrends = async (assetId, trendKeywordType, errorMessage = 'An error occurred. Please try again.') => {
  try {
    const response = await axios.get(dashboard.getTrendKeywords, {
      params: {
        assetId: assetId,
        trendKeywordType: trendKeywordType,
      },
    })

    return response.data.data || []
  } catch (error) {
    console.error('Error fetching trend keywords:', error)
    responseHandlerService.handleError(errorMessage)
    return []
  }
}
